import { createStore } from 'vuex'
import * as auth from './auth'
import * as route from './route'
import offer from './modules/offer'

const store = createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth: {
      namespaced: true,
      ...auth
    },
    route: {
      namespaced: true,
      ...route
    },
    offer
  }
})

export default store
